import Logo from "./Logo"
import Navbar from "./Navbar"

export default function Header() {
  return (
    <>
      <header className="header max-width p-5">
        <div>
          <Logo />
        </div>

        <>
          <Navbar />
        </>
      </header>
    </>
  )
}
